import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Html from 'slate-html-serializer';
import { Value, Block, Inline, Mark } from 'slate';
import nodeDataToAttributes from '../utils/nodeDataToAttributes';
export default function makeDefaultHTMLSerializer(editor, options) {
  function nodeSerializers(node, children) {
    var _editor$getSerializin = editor.getSerializingRules(),
        rules = _editor$getSerializin.html;

    var rule = rules[node.type];

    if (rule) {
      var attributes = nodeDataToAttributes(node.data);

      if (typeof rule === 'string') {
        return React.createElement(rule, _objectSpread({
          'data-type': node.type
        }, attributes), children);
      } else if (typeof rule === 'function') {
        return rule({
          node: node,
          attributes: _objectSpread({
            'data-type': node.type
          }, attributes),
          children: children
        }, options);
      }
    }

    if (Mark.isMark(node) || Inline.isInline(node)) {
      return React.createElement("span", Object.assign({
        "data-type": node.type
      }, nodeDataToAttributes(node.data)), children);
    } else if (Block.isBlock(node)) {
      return React.createElement("div", Object.assign({
        "data-type": node.type
      }, nodeDataToAttributes(node.data)), children);
    }
  }

  return function serialize(fragment) {
    var serializer = new Html({
      rules: [{
        serialize: nodeSerializers
      }]
    });
    var value = Value.create({
      document: fragment
    });
    return serializer.serialize(value);
  };
}